import { render, staticRenderFns } from "./PurchaseAdvisor.vue?vue&type=template&id=251c80f4&scoped=true&lang=pug"
import script from "./PurchaseAdvisor.vue?vue&type=script&lang=ts"
export * from "./PurchaseAdvisor.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseAdvisor.vue?vue&type=style&index=0&id=251c80f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251c80f4",
  null
  
)

export default component.exports